export interface WaveDef {
  count: number
  hp: number
  speed: number
  spacing: number // ms between spawns
  reward: number  // coins per kill
  type: 'basic' | 'fast' | 'tank' | 'boss'
}

export function getWave(waveNum: number): WaveDef {
  const base = {
    count: 5 + waveNum * 3,
    hp: 20 + waveNum * 15,
    speed: 50 + Math.min(waveNum * 3, 40),
    spacing: Math.max(400, 1200 - waveNum * 50),
    reward: 5 + Math.floor(waveNum / 2),
    type: 'basic' as const,
  }

  // Every 5th wave is a boss wave
  if (waveNum % 5 === 0 && waveNum > 0) {
    return {
      count: 1 + Math.floor(waveNum / 10),
      hp: base.hp * 10,
      speed: 30,
      spacing: 3000,
      reward: 50 + waveNum * 5,
      type: 'boss',
    }
  }

  // Every 3rd wave has some fast snowmen
  if (waveNum % 3 === 0) {
    return {
      ...base,
      count: base.count + 3,
      speed: base.speed * 1.5,
      hp: Math.floor(base.hp * 0.6),
      type: 'fast',
    }
  }

  // Every 4th wave has tanks
  if (waveNum % 4 === 0) {
    return {
      ...base,
      count: Math.floor(base.count * 0.6),
      hp: base.hp * 2.5,
      speed: base.speed * 0.7,
      reward: base.reward * 2,
      type: 'tank',
    }
  }

  return base
}
